import React, { useState, useEffect, useCallback } from "react";
import { Button, Table, Form } from "react-bootstrap";
import "./../../css/attendeeMapping.css";
import { getPassCode, checkApiError } from "../../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SearchedAttendeeList = ({
  isSubmitted,
  searchedValue,
  setIsSubmitted,
  eventId,
  setIsAddAttendee,
  showLoading,
  setSearchedValue,
  isRemoveAttendee,
  setisRemoveAttendee,
}) => {
  const navigate = useNavigate();
  const [searchedAttendeesPerPage, setSearchedAttendeesPerPage] = useState(5);
  const [isSeletAllSelected, setIsSeletAllSelected] = useState(false);
  const [searchedAttendees, setSearchedAttendees] = useState([]);
  const [originalDataCopy, setOriginalDataCopy] = useState([]);
  const [searchedAttendeesCurrentPage, setSearchedAttendeesCurrentPage] =
    useState(1);
  const searchedAttendeesPaginate = (pageNumber) =>
    setSearchedAttendeesCurrentPage(pageNumber);
  const [searchedAttendeesSelectedUser, setSearchedAttendeesSelectedUser] =
    useState([]);
  const searchedAttendeesIndexOfLastUser =
    searchedAttendeesCurrentPage * searchedAttendeesPerPage;
  const searchedAttendeesIndexOfFirstUser =
    searchedAttendeesIndexOfLastUser - searchedAttendeesPerPage;
  const [sortConfig, setSortConfig] = useState({
    key: "organization",
    direction: "asc",
  });

  const handleSearchedAttendeeSelection = (userId, event) => {
    let selectedUsers = null;
    if (event.target.checked) {
      selectedUsers = searchedAttendees.find((user) => user.userId === userId);
      selectedUsers.isSelected = true;
      setSearchedAttendeesSelectedUser([
        selectedUsers,
        ...searchedAttendeesSelectedUser,
      ]);
    } else {
      setSearchedAttendeesSelectedUser(
        searchedAttendeesSelectedUser.filter((user) => {
          if (user.userId === userId) {
            user.isSelected = false;
          }
          return user.userId !== userId;
        })
      );
    }
  };

  const getCABAttendeeList = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AttendanceMapping/GetAttendeesByEventIdandFlag?encoramemberflag=false&EventId=${eventId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
        }
      );
      if(checkApiError(response.status)){ navigate("/login"); return; }
      if (response.ok) {
        const data = await response.json();
        if (data.statusCode === 200) {
          let response = [];
          if (data.attendanceMappingDetails.length > 0) {
            response = data.attendanceMappingDetails.map((item, i) => {
              return { ...item, seqenceNumber: i + 1 };
            });
          } else {
            response = data.attendanceMappingDetails;
          }
          return response;
        }
      } else {
        console.error(
          "Error, Get all Mapped CAB attendee List:",
          response.status
        );
        return [];
      }
    } catch (error) {
      console.error("Error, Get all Mapped CAB attendee List:", error);
    }
  };

  const getEncoraAttendeeList = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AttendanceMapping/GetAttendeesByEventIdandFlag?encoramemberflag=true&EventId=${eventId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
        }
      );
      if(checkApiError(response.status)){ navigate("/login"); return; }
      if (response.ok) {
        const data = await response.json();
        if (data.statusCode === 200) {
          let response = [];
          if (data.attendanceMappingDetails.length > 0) {
            response = data.attendanceMappingDetails.map((item, i) => {
              return { ...item, seqenceNumber: i + 1 };
            });
          } else {
            response = data.attendanceMappingDetails;
          }
          return response;
        }
      } else {
        console.error(
          "Error, Get all Mapped Encora attendee List:",
          response.status
        );
        return [];
      }
    } catch (error) {
      console.error("Error, Get all Mapped Encora attendee List:", error);
    }
  };

  const getSearchAttendeeList = useCallback(async () => {
    try {
      showLoading(true);
      let CABData = await getCABAttendeeList();
      let EncoraData = await getEncoraAttendeeList();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Attendee/GetAll`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
        }
      );
      if(checkApiError(response.status)){ navigate("/login"); return; }
      if (response.ok) {
        const data = await response.json();
        if (data.statusCode === 200) {
          setSearchedValue("");

          // This logic is for if already records existed in CAB & Encora grid we are filtering in the Searh Attendee Grid
          let filteredCABDataFromAllData = data.data.filter((item1) => {
            return !CABData.some((item2) => item1.userId === item2.userId);
          });

          let addIndexToCABFilteredData = filteredCABDataFromAllData.map(
            (item, i) => {
              return { ...item, seqenceNumber: i + 1 };
            }
          );

          let filteredEncoraDataFromAllData = addIndexToCABFilteredData.filter(
            (item1) => {
              return !EncoraData.some((item2) => item1.userId === item2.userId);
            }
          );

          let addIndexToEncoraFilteredData = filteredEncoraDataFromAllData.map(
            (item, i) => {
              return { ...item, seqenceNumber: i + 1 };
            }
          );

          setSearchedAttendees(addIndexToEncoraFilteredData);
          setOriginalDataCopy(addIndexToEncoraFilteredData);
          setisRemoveAttendee(false);
        }
      } else {
        console.error("Error, Get all search attendee List:", response.status);
        setisRemoveAttendee(false);
      }
    } catch (error) {
      console.error("Error, Get all search attendee List:", error);
    } finally {
      showLoading(false);
    }
  }, [originalDataCopy]);

  useEffect(() => {
    getSearchAttendeeList();
  }, []);

  useEffect(() => {
    //This is For refresh the Search Attendee Grid after delete ENCORA or CAB Attendee grid records.
    if (isRemoveAttendee) {
      getSearchAttendeeList();
    }
  }, [isRemoveAttendee]);

  useEffect(() => {
    let resetAttendees = searchedAttendees.map((item) => ({
      ...item,
      isSelected: false,
    }));
    setSearchedAttendees(resetAttendees);
    setIsSeletAllSelected(false);
    setSearchedAttendeesSelectedUser([]);
  }, [searchedAttendeesCurrentPage]);

  const handleSearchedAttendeeCurrentPageCount = (e) => {
    if (e.target.value === "" || parseInt(e.target.value) === 0) {
      setSearchedAttendeesCurrentPage(1);
    } else if (parseInt(e.target.value) > searchedAttendeeTotalPages) {
      setSearchedAttendeesCurrentPage(searchedAttendeeTotalPages);
    } else {
      setSearchedAttendeesCurrentPage(parseInt(e.target.value));
    }
  };

  const searchedFilteredAttendees = searchedAttendees.filter((user) => {
    return Object.values(user).some(
      (value) =>
        value && value.toString().toLowerCase().includes("".toLowerCase())
    );
  });

  const searchedAttendeeTotalPages = Math.ceil(
    searchedFilteredAttendees.length / searchedAttendeesPerPage
  );

  // --- Updated to use the filtered attendees ---
  const currentSearchedAttendees =
    searchedAttendeeTotalPages === 1
      ? searchedFilteredAttendees
      : searchedFilteredAttendees.slice(
          searchedAttendeesIndexOfFirstUser,
          searchedAttendeesIndexOfLastUser
        );

  const renderCustomPaginationItems = () => {
    let items = [];
    //previous
    items.push(
      <button
        type="button"
        className="pg-btn pg-prev-btn"
        disabled={searchedAttendeesCurrentPage === 1}
        onClick={() =>
          searchedAttendeesPaginate(searchedAttendeesCurrentPage - 1)
        }
      >
        &nbsp;&nbsp;
      </button>
    );
    // Always show first page
    items.push(
      <button
        type="button"
        className="pg-btn"
        disabled={searchedAttendeesCurrentPage === 1}
        onClick={() => searchedAttendeesPaginate(1)}
      >
        1
      </button>
    );
    // Always show the second page
    if (searchedAttendeeTotalPages > 1 && searchedAttendeesCurrentPage < 3) {
      items.push(
        <button
          type="button"
          className="pg-btn"
          disabled={searchedAttendeesCurrentPage === 2}
          onClick={() => searchedAttendeesPaginate(2)}
        >
          2
        </button>
      );
    }

    // Always show the current page.  Put a conditional around this to prevent duplicates.
    if (
      searchedAttendeesCurrentPage !== 1 &&
      searchedAttendeesCurrentPage !== 2 &&
      searchedAttendeesCurrentPage !== searchedAttendeeTotalPages
    ) {
      items.push(
        <button
          type="button"
          className="pg-btn"
          disabled={searchedAttendeesCurrentPage !== searchedAttendeeTotalPages}
          onClick={() =>
            searchedAttendeesPaginate(searchedAttendeesCurrentPage)
          }
        >
          {searchedAttendeesCurrentPage}
        </button>
      );
    }

    // Show ellipsis if there are more pages between 2 and last
    if (searchedAttendeeTotalPages > 2) {
      items.push(
        <button type="button" className="pg-btn pg-eclipses-btn" disabled>
          &#8230;
        </button>
      );
    }

    // Always show last page if there is more than one page
    if (
      searchedAttendeeTotalPages > 1 &&
      items.length - 1 !== searchedAttendeeTotalPages
    ) {
      items.push(
        <button
          type="button"
          className="pg-btn"
          disabled={searchedAttendeesCurrentPage === searchedAttendeeTotalPages}
          onClick={() => searchedAttendeesPaginate(searchedAttendeeTotalPages)}
        >
          {searchedAttendeeTotalPages}
        </button>
      );
    }
    // Next
    items.push(
      <button
        type="button"
        className="pg-btn pg-next-btn"
        disabled={searchedAttendeesCurrentPage === searchedAttendeeTotalPages}
        onClick={() =>
          searchedAttendeesPaginate(searchedAttendeesCurrentPage + 1)
        }
      >
        &nbsp;&nbsp;
      </button>
    );

    return items;
  };

  const handleSearchedAttendiesPaginateShowCount = (e) => {
    if (e.target.value === "" || parseInt(e.target.value) === 0) {
      setSearchedAttendeesPerPage(0);
      setSearchedAttendeesCurrentPage(1);
      return;
    }
    const value =
      e.target.value >= searchedAttendees.length
        ? searchedAttendees.length
        : e.target.value;
    value < 0
      ? setSearchedAttendeesPerPage(0)
      : setSearchedAttendeesPerPage(value);
  };

  const handleAddAttendee = async () => {
    const arr = [];
    searchedAttendeesSelectedUser.map((item, index) => {
      return arr.push({
        attendeeMappingId: "",
        eventId: eventId,
        userId: item.userId,
        encoraMemberFlag: item.userType
          ? item.userType.toLowerCase() === "encora"
            ? true
            : false
          : false,
        seqenceNumber: index + 1,
        createdById: item.createdById,
        dateCreated: item.dateCreated,
        lastModifiedById: item.lastModifiedById,
        lastModifiedDate: item.lastModifiedDate,
      });
    });

    try {
      showLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AttendanceMapping/insertupdateAttendeemapping`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
          body: JSON.stringify({ attendeeMappings: arr }),
        }
      );
      if(checkApiError(response.status)){ navigate("/login"); return; }
      if (response.ok) {
        getSearchAttendeeList();
        setIsAddAttendee(true);
        setIsSeletAllSelected(false);
        toast.success("Searched Attendee Added Successfully");
      } else {
        console.error("Error, Add Attendee:", response.status);
        toast.error("Searched Attendee Adding Failed. Error!");
      }
    } catch (error) {
      toast.error("Searched Attendee Adding Failed. Error!");
      console.error("Error, Add Searched Attendee:", error);
    } finally {
      showLoading(false);
    }
  };

  const handleSelectAll = (event) => {
    let updatedArr = [];
    let startIndex =
      Number(searchedAttendeesPerPage) *
      (Number(searchedAttendeesCurrentPage) - 1);
    let endIndex =
      Number(searchedAttendeesPerPage) * Number(searchedAttendeesCurrentPage) -
      1;
    setIsSeletAllSelected(event.target.checked);
    if (event.target.checked) {
      updatedArr = searchedAttendees.map((obj, index) =>
        index >= startIndex && index <= endIndex
          ? { ...obj, isSelected: true }
          : obj
      );
      setSearchedAttendees(updatedArr);
      setSearchedAttendeesSelectedUser(
        updatedArr.filter((item) => item.isSelected)
      );
    } else {
      updatedArr = searchedAttendees.map((obj, index) =>
        index >= startIndex && index <= endIndex
          ? { ...obj, isSelected: false }
          : obj
      );
      setSearchedAttendees(updatedArr);
      setSearchedAttendeesSelectedUser([]);
    }
  };

  useEffect(() => {
    //This logic is used to handle search
    if (searchedValue.length === 0) {
      const data =
        originalDataCopy.length > 0 ? originalDataCopy : searchedAttendees;
      setSearchedAttendees(data.map((obj) => ({ ...obj, isSelected: false })));
      setIsSubmitted(false);
      setSearchedAttendeesSelectedUser([]);
      setIsSeletAllSelected(false);
    } else {
      setSearchedAttendees(
        originalDataCopy.filter(
          (row) =>
            (row.firstName &&
              row.firstName
                .toLowerCase()
                .includes(searchedValue.toLowerCase())) ||
            (row.lastName &&
              row.lastName
                .toLowerCase()
                .includes(searchedValue.toLowerCase())) ||
            (row.designation &&
              row.designation
                .toLowerCase()
                .includes(searchedValue.toLowerCase())) ||
            (row.organization &&
              row.organization
                .toLowerCase()
                .includes(searchedValue.toLowerCase()))
        )
      );
      setIsSubmitted(false);
      setSearchedAttendeesSelectedUser([]);
      setIsSeletAllSelected(false);
    }
  }, [isSubmitted]);

  const requestSort = () => {
    setSortConfig({
      ...sortConfig,
      direction: sortConfig.direction === "asc" ? "desc" : "asc",
    });
    const sortedAttendees = [...searchedFilteredAttendees].sort((a, b) => {
      if (sortConfig.key === null) {
        return 0; // No sorting
      }

      const valueA = a[sortConfig.key]
        ? a[sortConfig.key].toString().toLowerCase()
        : "";
      const valueB = b[sortConfig.key]
        ? b[sortConfig.key].toString().toLowerCase()
        : "";

      if (valueA < valueB) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setSearchedAttendees(sortedAttendees);
  };

  const showOutOfEntries = () => {
    const startEntry = searchedAttendeesPerPage === 0 ? 0 : (searchedAttendeesCurrentPage - 1) * searchedAttendeesPerPage + 1;
    const endEntry = Math.min(searchedAttendeesCurrentPage * searchedAttendeesPerPage, searchedAttendees.length);
    
    return (
        <>
        Showing <span className='color-black roboto-bold'>{startEntry}-{endEntry}</span> out of <span className='color-black roboto-bold'>{searchedAttendees.length}</span> Entries
        </>
    );
  };

  return (
    <div className="row mt-4 searchedAttendee">
      <div className="col-12">
        <div className="card border">
          <div className="card-body p-0">
            <div className="d-flex justify-content-between align-items-sm-center align-items-start p-4 pb-3 flex-column flex-sm-row">
              <p className="fw-500 m-sm-0 s-h mb-3">Searched Attendee List</p>
              <div className="action-btn-container">
                <div className="d-flex justify-content-start justify-content-sm-end align-items-center color-gray flex-wrap">
                  <Form.Group
                    controlId="search"
                    className="me-3 d-flex align-items-center hide"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Search" /* onChange={handleSearchChange} */
                    />
                  </Form.Group>

                  <Button
                    variant="purple"
                    onClick={() => handleAddAttendee()}
                    className="me-3"
                    disabled={searchedAttendeesSelectedUser.length === 0}
                  >
                    Add Attendee
                  </Button>

                  <div className="d-flex justify-content-center align-items-center ms-2">
                    Show{" "}
                    <input
                      className="form-control ms-2 me-2 text-center input-sm"
                      type="number"
                      value={searchedAttendeesPerPage}
                      onChange={handleSearchedAttendiesPaginateShowCount}
                      style={{
                        width: "45px", padding: "0.4rem 0.75rem"
                      }}
                    />{" "}
                    Entries
                  </div>
                </div>
              </div>
            </div>

            <Table responsive className="attendeeTable">
              <thead className="table-light">
                <tr>
                  <th
                    scope="col"
                    className="mw-70 text-center"
                    style={{ width: "70px" }}
                  >
                    {currentSearchedAttendees.length > 0 && (
                      <input
                        type="checkbox"
                        name="attendee"
                        checked={isSeletAllSelected}
                        className="searchedAttendeeCheckall icons icon-check"
                        onChange={(e) => handleSelectAll(e)}
                      />
                    )}{" "}
                  </th>
                  <th scope="col" className="mw-120">
                    First Name
                  </th>
                  <th scope="col" className="mw-120">
                    Last Name
                  </th>
                  <th scope="col" className="mw-120">
                    Designation
                  </th>
                  <th
                    scope="col"
                    className="mw-120"
                    onClick={() => requestSort()}
                    style={{ cursor: "pointer" }}
                  >
                    Organization
                    {sortConfig.key === "organization" && (
                      <span
                        className={`positiion-relative ms-1 icons icon-sort ${
                          sortConfig.direction === "asc"
                            ? "icon-sort-asc"
                            : "icon-sort-desc"
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-expand position-absolute"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708m0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708" />
                        </svg>
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody id="myTable">
                {currentSearchedAttendees.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No attendees found.
                    </td>
                  </tr>
                ) : (
                  currentSearchedAttendees.map((user) => (
                    <tr key={user.userId}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          name="attendee"
                          checked={user.isSelected}
                          className="btn-checkbox icons icon-checkbox icon-check"
                          onChange={(e) =>
                            handleSearchedAttendeeSelection(user.userId, e)
                          }
                        />
                      </td>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.designation}</td>
                      <td>{user.organization}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>

            {/* Pagination for the filtered attendees */}
            <div className="d-flex justify-content-between align-items-sm-center align-items-start ps-4 pe-4 mb-3 mt-1 flex-column flex-sm-row color-gray">
              <div className="m-sm-0 mb-3">{showOutOfEntries()}
              </div>
              <div className="d-flex align-items-center flex-wrap">
                {false &&
                <div className="d-flex justify-content-center align-items-center me-3 hide">
                  {" "}
                  Page
                  <input
                    className="form-control ms-2 me-2 text-center input-sm"
                    type="number"
                    disabled={
                      searchedAttendeesPerPage >= searchedAttendees.length
                    }
                    value={searchedAttendeesCurrentPage}
                    onChange={handleSearchedAttendeeCurrentPageCount}
                    style={{ width: "45px", padding: "0.4rem 0.75rem" }}
                  />{" "}
                  Entries
                </div>}
                {searchedAttendeesPerPage > 0 && (
                  <div className="custom-paginaton">
                    {renderCustomPaginationItems()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchedAttendeeList;
